import template from './mainNewsItem.html';
import controller from './mainNewsItem.controller';
import './mainNewsItem.scss';

let mainNewsItemComponent = {
  restrict: 'E',
  bindings: {selectedNews: '<'},
  template,
  controller
};

export default mainNewsItemComponent;



// WEBPACK FOOTER //
// ./client/app/components/news/mainNewsItem/mainNewsItem.component.js